import { render } from "./Channels.vue?vue&type=template&id=70f55d95"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"
script.render = render

export default script